<!-- prettier-ignore -->
<span quantity i18n="@@product.container-quantity.quantity.label">
  {quantity(), plural,
  =1 { {{ quantity() | i18nPlural: unitLabel() }}}
  other { {{ quantity() | number }} {{ quantity() | i18nPlural: unitLabel() }}}
  }
</span>
<span per>{{ containerUnitLabel() }}</span>
